import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/404'),
    meta: { title: '404' },
    hidden: true
  },
  {
    name: '405',
    path: '/405',
    component: () => import('@/views/405'),
    meta: { title: '权限不足' },
    hidden: true
  },

  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/login/index'),
    meta: { title: '登录' },
    hidden: true
  },

  {
    name: 'Link',
    path: '/link/index',
    component: () => import('@/views/link/index'),
    meta: { title: '链接' },
    hidden: true
  },

  {
    name: 'Dashboard',
    path: '/',
    redirect: '/dashboard',
    component: Layout,
    children: [
      {
        name: 'DashboardIndex',
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'dashboard' }
      }
    ]
  },

  {
    name: 'admin',
    path: '/admin',
    redirect: '/admin/role/index',
    component: Layout,
    meta: { title: '用户', icon: 'el-icon-user-solid' },
    children: [
      {
        name: 'roleIndex',
        path: '/role/index',
        component: () => import('@/views/admin/role/index'),
        meta: { title: '管理员', icon: 'el-icon-s-custom' }
      },
      {
        name: 'ordinaryIndex',
        path: '/ordinary/index',
        component: () => import('@/views/admin/ordinary/index'),
        meta: { title: '普通用户', icon: 'el-icon-user' }
      }
    ]
  },

  {
    name: 'settings',
    path: '/group',
    redirect: '/settings/group/index',
    component: Layout,
    meta: { title: '角色权限', icon: 'el-icon-setting' },
    children: [
      {
        name: 'group',
        path: '/group/index',
        component: () => import('@/views/settings/group/index'),
        meta: { title: '角色', icon: 'el-icon-user' }
      },
      {
        name: 'ruleIndex',
        path: '/rule/index',
        component: () => import('@/views/settings/rule/index'),
        meta: { title: '菜单', icon: 'el-icon-s-custom' }
      }
    ]
  },

  {
    name: 'Hardware',
    path: '/hardware',
    redirect: '/hardware',
    component: Layout,
    children: [
      {
        name: 'HardwareIndex',
        path: 'hardware',
        component: () => import('@/views/hardware/index'),
        meta: { title: '门牌查询', icon: 'dashboard' }
      }
    ]
  },
  {
    name: 'HardwareCursor',
    path: '/hardwareCursor',
    redirect: '/hardwareCursor',
    component: Layout,
    children: [
      {
        name: 'hardwareCursorIndex',
        path: 'hardwareCursor',
        component: () => import('@/views/hardwareCursor/index'),
        meta: { title: '门牌记录', icon: 'dashboard' }
      }
    ]
  },
  {
    name: 'template',
    path: '/template',
    redirect: '/template',
    component: Layout,
    children: [
      {
        name: 'templateIndex',
        path: 'template',
        component: () => import('@/views/template/index'),
        meta: { title: '模板', icon: 'dashboard' }
      }
    ]
  },
  {
    name: 'company',
    path: '/company',
    redirect: '/company',
    component: Layout,
    children: [
      {
        name: 'companyIndex',
        path: 'company',
        component: () => import('@/views/company/index'),
        meta: { title: '公司', icon: 'dashboard' }
      }
    ]
  },
  {
    name: 'dispose',
    path: '/dispose',
    redirect: '/dispose',
    component: Layout,
    children: [
      {
        name: 'disposeIndex',
        path: 'dispose',
        component: () => import('@/views/dispose/index'),
        meta: { title: '项目配置', icon: 'dashboard' }
      }
    ]
  },
  {
    name: 'DictManage',
    path: '/dict',
    component: Layout,
    children: [
      {
        name: 'DictManageIndex',
        path: 'index',
        component: () => import('@/views/dict/index'),
        meta: { title: '字典管理', icon: 'el-icon-notebook-2' }
      }
    ]
  },
  {
    name: 'ConfigManage',
    path: '/config',
    component: Layout,
    children: [
      {
        name: 'ConfigManageIndex',
        path: 'index',
        component: () => import('@/views/config/index'),
        meta: { title: '配置管理', icon: 'el-icon-setting' }
      }
    ]
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
